import { useAppSelector } from '@redux/hooks'
import { NoData } from '@components/noData'
import GuyStandingCircle from 'images/guy-standing-circle.svg'
import { t } from '@lingui/core/macro'

export function DisabledAccountGuard({ children }: { children: React.ReactNode }) {
  const account = useAppSelector(state => state.Auth.account)
  if (account.is_disabled) {
    return (
      <NoData
        svg={<GuyStandingCircle />}
        text={{
          title: account.disabled_message ?? t`This account has been deactivated.`,
          body: {
            mainText: t`If you have any questions, please contact support.`,
            helperText: {
              href: 'mailto:support@claravine.com',
              text: 'support@claravine.com',
            },
          },
        }}
      />
    )
  }

  return children
}
